<template>
  <div class="container map-container">
    <div class="func">
      <el-input
        v-model="cityName"
        placeholder="请输入搜索城市"
        @change="getLocation"
      >
        <template slot="prepend">请输入地区位置</template>
      </el-input>
      <div class="func-bar">
        <el-button @click="handleMarker" size="mini">
          <i class="iconfont icon-map-pin-fill"></i>
          {{ mode === "marker" ? "取消标记模式" : "标记点" }}
        </el-button>
        <el-button size="mini" @click="handlePolyline">
          <i class="iconfont icon-guizesheji-xuanzexianduan-hover"></i>
          {{ mode === "polyline" ? "取消绘制模式" : "绘制线" }}
        </el-button>
        <el-button size="mini" @click="handleShape">
          <i class="iconfont icon-guizesheji-xuanzexianduan-hover"></i>
          {{ mode === "shape" ? "取消绘制形状" : "绘制形状" }}
        </el-button>
      </div>
    </div>
    <div id="map"></div>

    <!-- 标记点添加对话框 -->
    <el-dialog
      title="添加标记点"
      :visible.sync="dialog"
      width="30%"
      @close="cancelMarker"
    >
      <div>
        <el-input
          v-model="markerName"
          placeholder="请输入标记点名称"
          @keyup.enter="confirmMarker"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelMarker">取 消</el-button>
        <el-button type="primary" @click="confirmMarker">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 标记点编辑抽屉 -->
    <el-drawer
      title="标记点编辑"
      :visible.sync="drawer"
      :before-close="cancelChaneMarker"
    >
      <el-form
        ref="form"
        style="box-sizing: border-box; padding: 20px"
        :model="markerForm"
      >
        <el-form-item label="名称：">
          <el-input v-model="markerForm.name"></el-input>
        </el-form-item>
        <el-form-item label="坐标：">
          <el-row :gutter="10" type="flex">
            <el-col :span="12">
              <el-input
                v-model="markerForm.location[0]"
                placeholder="经度"
              ></el-input>
            </el-col>
            <el-col :span="12">
              <el-input
                v-model="markerForm.location[1]"
                placeholder="纬度"
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="图标颜色：">
          <el-color-picker v-model="markerForm.iconColor"></el-color-picker>
        </el-form-item>
        <el-form-item label="图标形式：">
          <el-select v-model="markerForm.icon" placeholder="请选择">
            <el-option
              v-for="item in iconList"
              :key="item.content"
              :label="item.content"
              :value="item.iconName"
            >
              <i class="iconfont" :class="item.iconName"></i>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文字颜色：">
          <el-color-picker v-model="markerForm.fontColor"></el-color-picker>
        </el-form-item>
        <el-form-item label="背景颜色：">
          <el-color-picker v-model="markerForm.background"></el-color-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeMarker">修改</el-button>
          <el-button @click="cancelChaneMarker">取消</el-button>
          <el-button @click="deleteMarker" type="warning">删除</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

    <!-- 线段编辑抽屉 -->
    <el-drawer
      title="线段编辑"
      :visible.sync="lineDrawer"
      :before-close="cancelChangeLine"
    >
      <el-form
        ref="lineForm"
        style="box-sizing: border-box; padding: 20px"
        :model="lineForm"
        label-width="100px"
      >
        <el-form-item label="名称：">
          <el-input v-model="lineForm.name"></el-input>
        </el-form-item>
        <el-form-item label="线条颜色：">
          <el-color-picker
            v-model="lineForm.strokeColor"
            show-alpha
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="线条宽度：">
          <el-input-number
            v-model="lineForm.strokeWeight"
            :min="1"
            :max="10"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="线条样式：">
          <el-select v-model="lineForm.strokeStyle" placeholder="请选择">
            <el-option label="实线" value="solid"></el-option>
            <el-option label="虚线" value="dashed"></el-option>
            <el-option label="点线" value="dotted"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="线条透明：">
          <el-slider
            v-model="lineForm.strokeOpacity"
            :min="0"
            :max="1"
            :step="0.1"
          ></el-slider>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeLine">修改</el-button>
          <el-button @click="cancelChangeLine">取消</el-button>
          <el-button @click="deleteLine" type="warning">删除</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

    <!-- 图形编辑抽屉 -->
    <el-drawer
      title="图形编辑"
      :visible.sync="shapeDrawer"
      :before-close="cancelChangeShape"
    >
      <el-form
        ref="shapeForm"
        style="box-sizing: border-box; padding: 20px"
        :model="shapeForm"
        label-width="100px"
      >
        <el-form-item label="名称：">
          <el-input v-model="shapeForm.name"></el-input>
        </el-form-item>
        <el-form-item label="边框颜色：">
          <el-color-picker
            v-model="shapeForm.strokeColor"
            show-alpha
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="填充颜色：">
          <el-color-picker
            v-model="shapeForm.fillColor"
            show-alpha
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="边框宽度：">
          <el-input-number
            v-model="shapeForm.strokeWeight"
            :min="1"
            :max="10"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="边框样式：">
          <el-select v-model="shapeForm.strokeStyle" placeholder="请选择">
            <el-option label="实线" value="solid"></el-option>
            <el-option label="虚线" value="dashed"></el-option>
            <el-option label="点线" value="dotted"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="边框透明：">
          <el-slider
            v-model="shapeForm.strokeOpacity"
            :min="0"
            :max="1"
            :step="0.1"
          ></el-slider>
        </el-form-item>
        <el-form-item label="填充透明：">
          <el-slider
            v-model="shapeForm.fillOpacity"
            :min="0"
            :max="1"
            :step="0.1"
          ></el-slider>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeShape">修改</el-button>
          <el-button @click="cancelChangeShape">取消</el-button>
          <el-button @click="deleteShape" type="warning">删除</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import axios from "axios";
import { GAO_DE_FUNC_KEY, GAO_DE_LOAD_KEY } from "../utilis/enum";

export default {
  name: "Map",
  data() {
    return {
      map: null,
      AMapInstance: null,
      cityName: "",
      mode: "", // 当前操作模式：marker/polyline/shape
      dialog: false,
      markerName: "",
      markers: [],
      polylineList: [],
      tempPoint: [],
      tempLine: null,
      lines: [],
      tempLocation: null,

      // 形状相关数据
      tempShape: null, // 临时形状对象
      tempShapeType: "", // 形状类型：rectangle, circle, polygon
      tempShapeStart: null, // 形状起始点
      tempShapePoints: [], // 多边形点集合
      shapes: [], // 存储所有形状
      drawingShape: false, // 是否正在绘制形状
      mouseMoveHandler: null, // 鼠标移动事件处理器

      // 标记点编辑相关
      drawer: false,
      currentMarkerId: null,
      markerForm: {
        name: "",
        icon: "",
        location: [],
        fontColor: "#ffffff",
        background: "#2B86FF",
        iconColor: "#2B86FF",
      },
      iconList: [
        { content: "默认", iconName: "icon-dian" },
        { content: "地图", iconName: "icon-map-pin-fill" },
        { content: "教育", iconName: "icon-xuexiao" },
        { content: "办公", iconName: "icon-bangongbao" },
        { content: "公园", iconName: "icon-gongyuan" },
        { content: "医院", iconName: "icon-yiyuan" },
        { content: "商场", iconName: "icon-shangchang" },
      ],

      // 线段编辑相关
      lineDrawer: false,
      currentLineId: null,
      lineForm: {
        name: "",
        strokeColor: "#2B86FF",
        strokeWeight: 2,
        strokeStyle: "solid",
        strokeOpacity: 1,
        path: [],
      },

      // 图形编辑相关
      shapeDrawer: false,
      currentShapeId: null,
      shapeForm: {
        name: "",
        strokeColor: "#2B86FF",
        fillColor: "rgba(43, 134, 255, 0.2)",
        strokeWeight: 2,
        strokeStyle: "solid",
        strokeOpacity: 1,
        fillOpacity: 0.5,
      },
    };
  },
  async mounted() {
    await this.$nextTick();
    await this.initAMap();
    await this.getLocation();
    document.addEventListener("contextmenu", this.handleRightClickOnShape);
  },
  unmounted() {
    if (this.map) {
      this.map.off("click");
      this.map.off("mousemove");
      this.map.destroy();
    }
    document.removeEventListener("contextmenu", this.handleRightClickOnShape);
  },
  methods: {
    /* ========== 地图初始化与搜索相关方法 ========== */
    async initAMap() {
      try {
        if (this.map) return this.map;

        const AMap = await AMapLoader.load({
          key: GAO_DE_LOAD_KEY,
          version: "2.0",
          plugins: [],
        });

        this.AMapInstance = AMap;

        this.map = new AMap.Map("map", {
          viewMode: "3D",
          zoom: 11,
          center: [116.397428, 39.90923],
        });

        this.map.on("click", (event) => {
          this.handleMapClick(event);
        });

        return this.map;
      } catch (e) {
        console.error("地图初始化失败:", e);
        throw e;
      }
    },

    async getLocation() {
      try {
        if (!this.map) {
          await this.initAMap();
        }

        if (!this.cityName) {
          return;
        }

        const response = await axios.get(
          "https://restapi.amap.com/v3/place/text",
          {
            params: {
              key: GAO_DE_FUNC_KEY,
              keywords: this.cityName,
              city: this.cityName,
              output: "JSON",
              offset: 1,
              page: 1,
            },
          }
        );

        if (response.data.status !== "1") {
          console.error("API错误:", response.data.info);
          return;
        }

        if (!response.data.pois || response.data.pois.length === 0) {
          console.error("未找到相关地点");
          return;
        }

        const locationStr = response.data.pois[0].location;
        const location = locationStr
          .split(",")
          .map((cord) => parseFloat(cord.trim()));

        if (location.length !== 2 || isNaN(location[0]) || isNaN(location[1])) {
          console.error("坐标格式错误:", location);
          return;
        }

        this.map.setCenter(location);
      } catch (error) {
        console.error("获取位置失败:", error);
      }
    },

    /* ========== 地图点击事件处理 ========== */
    handleMapClick(event) {
      if (this.mode === "marker") {
        this.tempLocation = event.lnglat;
        this.markerName = `标记点-${this.markers.length + 1}`;
        this.dialog = true;
      }

      if (this.mode === "polyline") {
        this.tempPoint.push(event.lnglat);
        this.handleDrawerPolyline();
      }

      if (this.mode === "shape" && this.drawingShape) {
        this.handleShapeDrawing(event);
      }
    },

    /* ========== 标记点相关方法 ========== */
    handleMarker() {
      if (this.mode === "marker") {
        this.mode = "";
        this.$message.info("已退出标记模式");
      } else {
        this.mode = "marker";
        this.$message.success("已进入标记模式，请点击地图添加标记点");
      }
    },

    confirmMarker() {
      if (!this.markerName.trim()) {
        this.$message.warning("请输入标记点名称");
        return;
      }

      if (!this.tempLocation) {
        this.$message.warning("没有找到标记位置");
        return;
      }

      if (!this.AMapInstance) return;

      const lng = this.tempLocation.lng;
      const lat = this.tempLocation.lat;

      console.log("创建标记的坐标:", lng, lat);

      try {
        const marker = new this.AMapInstance.Marker({
          position: [lng, lat],
          title: this.markerName,
          map: this.map,
          content: this.creatMarkerContent({
            name: this.markerName,
            iconColor: "#2B86FF",
            fontColor: "#ffffff",
            background: "#2B86FF",
          }),
          offset: new this.AMapInstance.Pixel(-5, -5),
        });

        // 生成唯一ID
        marker.markerId = Date.now() + Math.random();
        marker.markerName = this.markerName;

        marker.on("click", (e) => {
          this.handleMarkerContent(e.target);
        });

        // 保存到数组
        this.markers.push({
          marker: marker,
          name: this.markerName,
          location: [lng, lat],
          fontColor: "#ffffff",
          background: "#2B86FF",
          iconColor: "#2B86FF",
          icon: "icon-dian",
        });

        this.$message.success(`标记点"${this.markerName}"添加成功`);
        this.closeDialog();
      } catch (e) {
        console.error(e);
        this.$message.error("创建标记失败");
      }
    },

    cancelMarker() {
      this.$message.info("已取消添加标记");
      this.closeDialog();
    },

    closeDialog() {
      this.dialog = false;
      this.tempLocation = null;
      this.markerName = "";
      this.mode = "";
    },

    handleMarkerContent(marker) {
      const markerInfo = this.markers.find(
        (item) => item.marker.markerId === marker.markerId
      );

      if (markerInfo) {
        this.currentMarkerId = marker.markerId;

        this.markerForm = {
          name: markerInfo.name,
          location: [...markerInfo.location],
          fontColor: markerInfo.fontColor || "#ffffff",
          background: markerInfo.background || "#2B86FF",
          iconColor: markerInfo.iconColor || "#2B86FF",
          icon: markerInfo.icon || "icon-dian",
        };

        this.drawer = true;
      }
    },

    creatMarkerContent(options = {}) {
      const {
        iconColor = "#2B86FF",
        fontColor = "#ffffff",
        background = "#2B86FF",
        name = "",
        icon = "icon-dian",
      } = options;

      return `<div style="position: relative;display: flex;flex-direction: row;align-items: center">
        <i class="iconfont ${icon}" style="font-size: 24px;color: ${iconColor};" ></i>
        <div style="height:18px;line-height:18px;color:${fontColor};position: absolute; left: 30px; background: ${background}; padding: 2px 15px ; white-space: nowrap;border-radius: 4px;font-size: 12px;text-align: center">${name}</div>
      </div>`;
    },

    changeMarker() {
      if (!this.currentMarkerId) {
        this.$message.warning("未找到要修改的标记点");
        return;
      }

      const index = this.markers.findIndex(
        (item) => item.marker.markerId === this.currentMarkerId
      );

      if (index === -1) {
        this.$message.warning("标记点不存在");
        return;
      }

      const markerItem = this.markers[index];
      const marker = markerItem.marker;

      if (!this.markerForm.name.trim()) {
        this.$message.warning("请输入标记点名称");
        return;
      }

      const lng = parseFloat(this.markerForm.location[0]);
      const lat = parseFloat(this.markerForm.location[1]);

      if (isNaN(lng) || isNaN(lat)) {
        this.$message.warning("请输入有效的经纬度坐标");
        return;
      }

      try {
        marker.setPosition([lng, lat]);
        marker.setTitle(this.markerForm.name);
        marker.setContent(
          this.creatMarkerContent({
            iconColor: this.markerForm.iconColor,
            fontColor: this.markerForm.fontColor,
            background: this.markerForm.background,
            name: this.markerForm.name,
            icon: this.markerForm.icon,
          })
        );

        markerItem.name = this.markerForm.name;
        markerItem.location = [lng, lat];
        markerItem.fontColor = this.markerForm.fontColor;
        markerItem.background = this.markerForm.background;
        markerItem.iconColor = this.markerForm.iconColor;
        markerItem.icon = this.markerForm.icon;

        this.$set(this.markers, index, { ...markerItem });
        this.$message.success("标记点修改成功");
        this.drawer = false;
      } catch (error) {
        console.error("修改标记点失败:", error);
        this.$message.error("修改失败");
      }
    },

    cancelChaneMarker() {
      this.markerForm = {
        name: "",
        location: [],
        fontColor: "#ffffff",
        background: "#2B86FF",
        iconColor: "#2B86FF",
      };

      this.currentMarkerId = null;
      this.drawer = false;
    },

    deleteMarker() {
      const index = this.markers.findIndex(
        (item) => item.marker.markerId === this.currentMarkerId
      );

      if (index === -1) {
        this.$message.warning("标记点不存在");
        return;
      }

      const marker = this.markers[index].marker;
      this.map.remove(marker);
      this.markers.splice(index, 1);
      this.drawer = false;
      this.markerForm = {
        name: "",
        location: [],
        fontColor: "#ffffff",
        background: "#2B86FF",
        iconColor: "#2B86FF",
        icon: "icon-dian",
      };

      this.currentMarkerId = null;
      this.$message.success("标记点删除成功");
    },

    /* ========== 线段绘制相关方法 ========== */
    handlePolyline() {
      if (this.mode === "polyline") {
        this.mode = "";

        if (this.tempLine) {
          // 完成当前线段的绘制
          const lineId = this.tempLine.lineId;
          const lineIndex = this.lines.findIndex((line) => line.id === lineId);

          if (lineIndex !== -1) {
            // 更新路径
            this.lines[lineIndex].path = [...this.tempPoint];
            this.$message.success(
              `线段"${this.lines[lineIndex].name}"绘制完成`
            );
          }

          this.tempLine = null;
          this.tempPoint = [];
        }

        this.$message.info("已退出绘制线段模式");
      } else {
        this.mode = "polyline";
        this.tempPoint = [];
        this.$message.success("已进入线段编辑模式，请点击地图添加线段定点");
      }
    },

    handleDrawerPolyline() {
      if (this.tempPoint.length > 1) {
        if (!this.tempLine) {
          // 生成唯一ID
          const lineId = Date.now() + Math.random();

          this.tempLine = new this.AMapInstance.Polyline({
            path: this.tempPoint,
            strokeColor: "#2B86FF",
            strokeWeight: 2,
            strokeOpacity: 1,
            strokeStyle: "solid",
            lineJoin: "round",
            lineCap: "round",
            zIndex: 40,
            bubble: true,
            clickable: true,
          });

          // 添加点击事件用于编辑
          this.tempLine.lineId = lineId;
          this.tempLine.on("click", () => {
            this.handleLineContent(lineId);
          });

          this.map.add(this.tempLine);

          this.lines.push({
            id: lineId,
            name: `线段-${this.lines.length + 1}`,
            line: this.tempLine,
            path: [...this.tempPoint],
            strokeColor: "#2B86FF",
            strokeWeight: 2,
            strokeOpacity: 1,
            strokeStyle: "solid",
          });
        }
        this.tempLine.setPath(this.tempPoint);
      }
    },

    /* ========== 线段编辑相关方法 ========== */
    // 处理线段点击事件
    handleLineContent(lineId) {
      const lineInfo = this.lines.find((item) => item.id === lineId);

      if (lineInfo) {
        this.currentLineId = lineId;

        // 从线段对象获取当前样式
        const options = lineInfo.line.getOptions();

        this.lineForm = {
          name: lineInfo.name,
          strokeColor: options.strokeColor || "#2B86FF",
          strokeWeight: options.strokeWeight || 2,
          strokeStyle: options.strokeStyle || "solid",
          strokeOpacity: options.strokeOpacity || 1,
          path: [...lineInfo.path],
        };

        this.lineDrawer = true;
      }
    },

    // 修改线段样式
    changeLine() {
      if (!this.currentLineId) {
        this.$message.warning("未找到要修改的线段");
        return;
      }

      const index = this.lines.findIndex(
        (item) => item.id === this.currentLineId
      );

      if (index === -1) {
        this.$message.warning("线段不存在");
        return;
      }

      const lineItem = this.lines[index];
      const line = lineItem.line;

      try {
        // 更新线段样式
        line.setOptions({
          strokeColor: this.lineForm.strokeColor,
          strokeWeight: this.lineForm.strokeWeight,
          strokeStyle: this.lineForm.strokeStyle,
          strokeOpacity: this.lineForm.strokeOpacity,
        });

        // 更新存储的信息
        lineItem.name = this.lineForm.name;
        lineItem.strokeColor = this.lineForm.strokeColor;
        lineItem.strokeWeight = this.lineForm.strokeWeight;
        lineItem.strokeStyle = this.lineForm.strokeStyle;
        lineItem.strokeOpacity = this.lineForm.strokeOpacity;

        this.$set(this.lines, index, { ...lineItem });
        this.$message.success("线段修改成功");
        this.lineDrawer = false;
      } catch (error) {
        console.error("修改线段失败:", error);
        this.$message.error("修改失败");
      }
    },

    // 取消线段编辑
    cancelChangeLine() {
      this.lineForm = {
        name: "",
        strokeColor: "#2B86FF",
        strokeWeight: 2,
        strokeStyle: "solid",
        strokeOpacity: 1,
        path: [],
      };

      this.currentLineId = null;
      this.lineDrawer = false;
    },

    // 删除线段
    deleteLine() {
      const index = this.lines.findIndex(
        (item) => item.id === this.currentLineId
      );

      if (index === -1) {
        this.$message.warning("线段不存在");
        return;
      }

      const line = this.lines[index].line;
      this.map.remove(line);
      this.lines.splice(index, 1);
      this.lineDrawer = false;
      this.lineForm = {
        name: "",
        strokeColor: "#2B86FF",
        strokeWeight: 2,
        strokeStyle: "solid",
        strokeOpacity: 1,
        path: [],
      };

      this.currentLineId = null;
      this.$message.success("线段删除成功");
    },

    /* ========== 形状绘制相关方法 ========== */
    handleShape() {
      if (this.mode === "shape") {
        this.mode = "";
        this.drawingShape = false;
        this.resetShapeDrawing();
        this.$message.info("已退出绘制形状");
      } else {
        this.mode = "shape";
        this.$message.success("已进入绘制模式，右键选择创建形状");
      }
    },

    handleShapeDrawing(event) {
      const point = event.lnglat;
      switch (this.tempShapeType) {
        case "rectangle":
          if (!this.tempShapeStart) {
            this.tempShapeStart = point;
            this.tempShape = new this.AMapInstance.Rectangle({
              bounds: new this.AMapInstance.Bounds(point, point),
              strokeColor: "#2B86FF",
              strokeWeight: 2,
              strokeOpacity: 1,
              strokeStyle: "solid",
              fillColor: "rgba(43, 134, 255, 0.2)",
              fillOpacity: 0.5,
              cursor: "crosshair",
              clickable: false,
              bubble: true,
            });
            this.map.add(this.tempShape);
            this.$message.info("请拖动鼠标绘制矩形，再次点击完成");
            this.mouseMoveHandler = (moveEvent) => {
              this.updateRectangle(moveEvent.lnglat);
            };
            this.map.on("mousemove", this.mouseMoveHandler);
          } else {
            this.finishRectangle();
          }
          break;

        case "circle":
          if (!this.tempShapeStart) {
            this.tempShapeStart = point;
            this.tempShape = new this.AMapInstance.Circle({
              center: point,
              radius: 1,
              strokeColor: "#2B86FF",
              strokeWeight: 2,
              strokeOpacity: 1,
              strokeStyle: "solid",
              fillColor: "rgba(43, 134, 255, 0.2)",
              fillOpacity: 0.5,
              cursor: "crosshair",
              clickable: false,
              bubble: true,
            });
            this.map.add(this.tempShape);
            this.$message.info("请拖动鼠标绘制圆形，再次点击完成");

            this.mouseMoveHandler = (moveEvent) => {
              this.updateCircle(moveEvent.lnglat);
            };
            this.map.on("mousemove", this.mouseMoveHandler);
          } else {
            this.finishCircle();
          }
          break;

        case "polygon":
          this.tempShapePoints.push(point);

          if (!this.tempShape) {
            this.tempShape = new this.AMapInstance.Polygon({
              path: this.tempShapePoints,
              strokeColor: "#2B86FF",
              strokeWeight: 2,
              strokeOpacity: 1,
              strokeStyle: "solid",
              fillColor: "rgba(43, 134, 255, 0.2)",
              fillOpacity: 0.5,
              cursor: "pointer",
              clickable: false,
              bubble: true,
            });
            this.map.add(this.tempShape);
          } else {
            this.tempShape.setPath(this.tempShapePoints);
          }

          this.$message.info(
            `已添加第${this.tempShapePoints.length}个点，右键结束绘制`
          );
          break;
      }
    },

    updateRectangle(currentPoint) {
      if (this.tempShape && this.tempShapeStart) {
        const bounds = new this.AMapInstance.Bounds(
          this.tempShapeStart,
          currentPoint
        );
        this.tempShape.setBounds(bounds);
      }
    },

    updateCircle(currentPoint) {
      if (this.tempShape && this.tempShapeStart) {
        const radius = this.calculateDistance(
          this.tempShapeStart,
          currentPoint
        );
        this.tempShape.setRadius(radius);
      }
    },

    finishRectangle() {
      this.map.off("mousemove", this.mouseMoveHandler);

      // 设置为可点击，并添加点击事件
      this.tempShape.setOptions({
        clickable: true,
        cursor: "default",
      });

      const shapeId = Date.now();
      this.shapes.push({
        id: shapeId,
        type: "rectangle",
        object: this.tempShape,
        bounds: [
          this.tempShapeStart,
          this.tempShape.getBounds().getSouthEast(),
        ],
        name: `矩形-${this.shapes.length + 1}`,
        strokeColor: "#2B86FF",
        fillColor: "rgba(43, 134, 255, 0.2)",
        strokeWeight: 2,
        strokeStyle: "solid",
        strokeOpacity: 1,
        fillOpacity: 0.5,
      });

      // 添加点击事件用于编辑
      this.tempShape.on("click", () => {
        this.handleShapeContent(shapeId);
      });

      this.$message.success("矩形绘制完成");
      this.resetShapeDrawing();
      this.$message.info("可以继续绘制其他形状，或点击按钮退出绘制模式");
    },

    finishCircle() {
      this.map.off("mousemove", this.mouseMoveHandler);

      // 设置为可点击，并添加点击事件
      this.tempShape.setOptions({
        clickable: true,
        cursor: "default",
      });

      const shapeId = Date.now();
      this.shapes.push({
        id: shapeId,
        type: "circle",
        object: this.tempShape,
        center: this.tempShapeStart,
        radius: this.tempShape.getRadius(),
        name: `圆形-${this.shapes.length + 1}`,
        strokeColor: "#2B86FF",
        fillColor: "rgba(43, 134, 255, 0.2)",
        strokeWeight: 2,
        strokeStyle: "solid",
        strokeOpacity: 1,
        fillOpacity: 0.5,
      });

      // 添加点击事件用于编辑
      this.tempShape.on("click", () => {
        this.handleShapeContent(shapeId);
      });

      this.$message.success("圆形绘制完成");
      this.resetShapeDrawing();
      this.$message.info("可以继续绘制其他形状，或点击按钮退出绘制模式");
    },

    finishPolygon() {
      if (this.tempShapePoints.length < 3) {
        this.$message.warning("多边形至少需要3个点");
        return;
      }

      // 设置为可点击，并添加点击事件
      this.tempShape.setOptions({
        clickable: true,
        cursor: "default",
      });

      const shapeId = Date.now();
      this.shapes.push({
        id: shapeId,
        type: "polygon",
        object: this.tempShape,
        points: [...this.tempShapePoints],
        name: `多边形-${this.shapes.length + 1}`,
        strokeColor: "#2B86FF",
        fillColor: "rgba(43, 134, 255, 0.2)",
        strokeWeight: 2,
        strokeStyle: "solid",
        strokeOpacity: 1,
        fillOpacity: 0.5,
      });

      // 添加点击事件用于编辑
      this.tempShape.on("click", () => {
        this.handleShapeContent(shapeId);
      });

      this.$message.success("多边形绘制完成");
      this.resetShapeDrawing();
      this.$message.info("可以继续绘制其他形状，或点击按钮退出绘制模式");
    },

    calculateDistance(point1, point2) {
      const dx = point1.lng - point2.lng;
      const dy = point1.lat - point2.lat;
      const distance = Math.sqrt(dx * dx + dy * dy) * 111000;
      return Math.max(10, distance);
    },

    resetShapeDrawing() {
      this.tempShape = null;
      this.tempShapeType = "";
      this.tempShapeStart = null;
      this.tempShapePoints = [];
      this.drawingShape = false;
      this.mouseMoveHandler = null;
      this.map.off("mousemove");
    },

    // 处理图形点击事件
    handleShapeContent(shapeId) {
      const shapeInfo = this.shapes.find((item) => item.id === shapeId);

      if (shapeInfo) {
        this.currentShapeId = shapeId;

        // 从图形对象获取当前样式
        const options = shapeInfo.object.getOptions();

        this.shapeForm = {
          name: shapeInfo.name,
          strokeColor: options.strokeColor || "#2B86FF",
          fillColor: options.fillColor || "rgba(43, 134, 255, 0.2)",
          strokeWeight: options.strokeWeight || 2,
          strokeStyle: options.strokeStyle || "solid",
          strokeOpacity: options.strokeOpacity || 1,
          fillOpacity: options.fillOpacity || 0.5,
        };

        this.shapeDrawer = true;
      }
    },

    // 修改图形样式
    changeShape() {
      if (!this.currentShapeId) {
        this.$message.warning("未找到要修改的图形");
        return;
      }

      const index = this.shapes.findIndex(
        (item) => item.id === this.currentShapeId
      );

      if (index === -1) {
        this.$message.warning("图形不存在");
        return;
      }

      const shapeItem = this.shapes[index];
      const shape = shapeItem.object;

      try {
        // 更新图形样式
        shape.setOptions({
          strokeColor: this.shapeForm.strokeColor,
          fillColor: this.shapeForm.fillColor,
          strokeWeight: this.shapeForm.strokeWeight,
          strokeStyle: this.shapeForm.strokeStyle,
          strokeOpacity: this.shapeForm.strokeOpacity,
          fillOpacity: this.shapeForm.fillOpacity,
        });

        // 更新存储的信息
        shapeItem.name = this.shapeForm.name;
        shapeItem.strokeColor = this.shapeForm.strokeColor;
        shapeItem.fillColor = this.shapeForm.fillColor;
        shapeItem.strokeWeight = this.shapeForm.strokeWeight;
        shapeItem.strokeStyle = this.shapeForm.strokeStyle;
        shapeItem.strokeOpacity = this.shapeForm.strokeOpacity;
        shapeItem.fillOpacity = this.shapeForm.fillOpacity;

        this.$set(this.shapes, index, { ...shapeItem });
        this.$message.success("图形修改成功");
        this.shapeDrawer = false;
      } catch (error) {
        console.error("修改图形失败:", error);
        this.$message.error("修改失败");
      }
    },

    // 取消图形编辑
    cancelChangeShape() {
      this.shapeForm = {
        name: "",
        strokeColor: "#2B86FF",
        fillColor: "rgba(43, 134, 255, 0.2)",
        strokeWeight: 2,
        strokeStyle: "solid",
        strokeOpacity: 1,
        fillOpacity: 0.5,
      };

      this.currentShapeId = null;
      this.shapeDrawer = false;
    },

    // 删除图形
    deleteShape() {
      const index = this.shapes.findIndex(
        (item) => item.id === this.currentShapeId
      );

      if (index === -1) {
        this.$message.warning("图形不存在");
        return;
      }

      const shape = this.shapes[index].object;
      this.map.remove(shape);
      this.shapes.splice(index, 1);
      this.shapeDrawer = false;
      this.shapeForm = {
        name: "",
        strokeColor: "#2B86FF",
        fillColor: "rgba(43, 134, 255, 0.2)",
        strokeWeight: 2,
        strokeStyle: "solid",
        strokeOpacity: 1,
        fillOpacity: 0.5,
      };

      this.currentShapeId = null;
      this.$message.success("图形删除成功");
    },

    /* ========== 右键菜单相关方法 ========== */
    handleRightClickOnShape(event) {
      event.preventDefault();
      const mapElement = document.querySelector("#map");
      const isInMap = this.isPointInElementRect(event, mapElement);
      if (!isInMap || this.mode !== "shape") {
        return;
      }

      this.showShapeMenu(event.clientX, event.clientY);
    },

    showShapeMenu(x, y) {
      let menu = document.querySelector("#shape-context-menu");

      if (!menu) {
        menu = document.createElement("div");
        menu.id = "shape-context-menu";
        menu.style.cssText = `
          position: fixed;
          left: ${x}px;
          top: ${y}px;
          background: white;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          padding: 5px 5px;
          min-width: 140px;
          z-index: 2000;
          font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
          display: block;
        `;

        const menuItems = [
          { text: "绘制矩形", icon: "icon-juxing", action: "rectangle" },
          { text: "绘制圆形", icon: "icon-yuanxing", action: "circle" },
          { text: "绘制多边形", icon: "icon-duobianxing", action: "polygon" },
          { type: "divider" },
          {
            text: this.tempShapeType === "polygon" ? "完成绘制" : "取消",
            icon:
              this.tempShapeType === "polygon"
                ? "icon-wancheng"
                : "icon-guanbi",
            action: this.tempShapeType === "polygon" ? "finish" : "cancel",
          },
        ];

        menuItems.forEach((item) => {
          if (item.type === "divider") {
            const divider = document.createElement("div");
            divider.style.cssText = `
              height: 1px;
              background-color: #ebeef5;
              margin: 5px 0;
            `;
            menu.appendChild(divider);
          } else {
            const menuItem = document.createElement("div");
            menuItem.className = "menu-item";
            menuItem.dataset.action = item.action;
            menuItem.style.cssText = `
              padding: 8px 16px;
              cursor: pointer;
              font-size: 14px;
              color: #606266;
              display: flex;
              align-items: center;
              border-radius: 8px;
              transition: background-color 0.2s;
            `;

            if (item.icon) {
              const icon = document.createElement("i");
              icon.className = `iconfont ${item.icon}`;
              icon.style.cssText = `
                margin-right: 8px;
                font-size: 16px;
                color: #409eff;
              `;
              menuItem.appendChild(icon);
            }

            const text = document.createElement("span");
            text.textContent = item.text;
            menuItem.appendChild(text);

            menuItem.addEventListener("mouseenter", function () {
              this.style.backgroundColor = "rgba(58,142,230,0.14)";
              this.style.color = "rgba(58,142,230)";
            });

            menuItem.addEventListener("mouseleave", function () {
              this.style.backgroundColor = "";
              this.style.color = "";
            });

            menuItem.addEventListener("click", (e) => {
              e.stopPropagation();
              this.handleShapeMenuAction(item.action);
            });

            menu.appendChild(menuItem);
          }
        });

        document.body.appendChild(menu);
      } else {
        menu.style.display = "block";
        menu.style.left = `${x}px`;
        menu.style.top = `${y}px`;
      }
    },

    handleShapeMenuAction(action) {
      switch (action) {
        case "rectangle":
          this.startDrawingRectangle();
          break;
        case "circle":
          this.startDrawingCircle();
          break;
        case "polygon":
          this.startDrawingPolygon();
          break;
        case "finish":
          if (this.tempShapeType === "polygon") {
            this.finishPolygon();
          }
          this.closeShapeMenu();
          break;
        case "cancel":
          // 清除临时形状
          if (this.tempShape) {
            this.map.remove(this.tempShape);
          }
          this.resetShapeDrawing();
          // 退出形状模式
          this.mode = "";
          this.$message.info("已取消绘制并退出形状模式");
          this.closeShapeMenu();
          break;
      }
    },

    startDrawingRectangle() {
      this.drawingShape = true;
      this.tempShapeType = "rectangle";
      this.tempShapeStart = null;
      this.$message.info("请点击地图选择矩形起始点");
      this.closeShapeMenu();
    },

    startDrawingCircle() {
      this.drawingShape = true;
      this.tempShapeType = "circle";
      this.tempShapeStart = null;
      this.$message.info("请点击地图选择圆心");
      this.closeShapeMenu();
    },

    startDrawingPolygon() {
      this.drawingShape = true;
      this.tempShapeType = "polygon";
      this.tempShapePoints = [];
      this.$message.info("请点击地图添加多边形顶点，右键完成绘制");
      this.closeShapeMenu();
    },

    closeShapeMenu() {
      const menu = document.querySelector("#shape-context-menu");
      if (menu) {
        menu.style.display = "none";
      }
    },

    /* ========== 通用工具方法 ========== */
    isPointInElementRect(event, element) {
      const rect = element.getBoundingClientRect();
      return (
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/common/style/index";

.map-container {
  position: relative;
  box-sizing: border-box;

  .func {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 999;
    display: flex;
    flex-direction: row;

    .func-bar {
      border-radius: 8px;
      padding: 4px 8px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
      background-color: #ffffff;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 40px;
    }
  }

  #map {
    height: 100%;
    width: 100%;
    border-radius: $main_border_radius;
    overflow: hidden;
  }

  ::v-deep .el-drawer {
    width: 500px;

    .el-drawer__body > * {
      max-width: 100% !important;
      box-sizing: border-box !important;
    }
  }
}
</style>
